import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/ui/Loading';
import { getMsalClientId, MSAL_MAIL_LOGIN_SESSION_KEY } from '../auth/msalConfig';

/**
 * OAuth redirect target from Microsoft. Bootstrap (msalBootstrap) stores token in sessionStorage.
 * We immediately send the user into the mail module; MailSummaryPage consumes the token.
 */
const MailCallCallbackPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const hash = (window.location.hash || '').replace(/^#/, '');
    const hashParams = hash ? new URLSearchParams(hash) : new URLSearchParams();
    const oauthError = search.get('error') || hashParams.get('error');
    const oauthDesc = search.get('error_description') || hashParams.get('error_description');
    if (oauthError) {
      const msg = oauthDesc
        ? decodeURIComponent(oauthDesc.replace(/\+/g, ' '))
        : oauthError;
      setError(msg);
      return;
    }

    if (!getMsalClientId()) {
      setError(
        'MSAL istemci kimliği tanımlı değil. .env içinde REACT_APP_MSAL_CLIENT_ID veya public/index.html içinde window.ENV.MSAL_CLIENT_ID ayarlayın.'
      );
      return;
    }

    sessionStorage.removeItem(MSAL_MAIL_LOGIN_SESSION_KEY);
    navigate('/mail/summary', { replace: true });
  }, [navigate]);

  const dismissError = () => setError(null);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 px-6 py-8">
        <div className="max-w-3xl mx-auto">
          <div
            className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded dark:bg-red-900/20 dark:border-red-800 dark:text-red-300 flex justify-between items-start gap-2"
            role="alert"
          >
            <span>{error}</span>
            <button
              type="button"
              onClick={dismissError}
              className="ml-2 text-red-500 hover:text-red-700 dark:hover:text-red-400 shrink-0"
              aria-label="Kapat"
            >
              ×
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <Loading fullScreen={true} message="Microsoft oturumu tamamlanıyor..." />;
};

export default MailCallCallbackPage;
